module.exports = __webpack_public_path__ + "resources/img/img-tmax-hyper-sql-for-postgre-sql-01-m-jp.30549fe211e69a8f8421d217dcf262eb.png";